import React, {Component} from 'react';
import Download from '../../../Resources/Images/download.svg';
import './Document.css';
import Placeholder from "../../../Resources/Images/16x9.png";
import ShareButton from "../../../Resources/Images/icon-share.png";
import IntersectionVisible from "react-intersection-visible";
import $ from 'jquery';


class Document extends Component {
  constructor(props) {
    super(props);
    this.state = {
      widget: 'widget' + this.props.document.id,
      src: "https://www.youtube.com/embed/" + this.props.document.yid + "?rel=0&iv_load_policy=0&h1=de&controls=2&color=white&autoplay=0&fs=1&playsinline=1&origin=" + window.location.hostname + "&enablejsapi=1&widgetid=" + this.props.document.id
    };
    this.downloadFile = this.downloadFile.bind(this);
  }

  downloadFile(e, file) {
    e.preventDefault();
    this.props.setFile(file);
    this.props.changeRoute('PDF');
  }

  onHide(entries) {
  }

  onShow(entries) {
    $("." + this.state.widget).attr('src', this.state.src);
  }

  onIntersect(entries) {
  }

  render() {
    if (this.props.document.format === 'pdf') {
      console.log(this.props.document.url);
      return <tr className="document-listview" data-uid={this.props.document.id}>
        <td className="spacing"><a className="no-select" href=""
                                   onClick={(event) => this.downloadFile(event, this.props.document.url)}>{this.props.document.title}</a>
        </td>
        <td className="spacing"><a className="no-select" href=""
                                   onClick={(event) => this.downloadFile(event, this.props.document.url)}><img
          src={Download} alt="Download"/></a></td>
      </tr>
    } else if (this.props.document.format === 'youtube') {
      return <tr className="youtube-player loaded" data-id={this.props.document.yid}>
        <td>
          <IntersectionVisible onIntersect={e => this.onIntersect(e)}
                               onHide={e => this.onHide(e)}
                               onShow={e => this.onShow(e)}>
            <div className="video-wrapper">
              <iframe
                frameBorder="0"
                allowFullScreen="allowFullScreen"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                title={this.props.document.title} width="640" height="360"
                src=""
                className={this.state.widget}
                id={this.state.widget}/>
              <img src={Placeholder} alt="resolution-adjuster" className="resolution-adjuster"/>
            </div>
          </IntersectionVisible>
        </td>
      </tr>


    }
    return null;
  }
}

export default Document;



// WEBPACK FOOTER //
// ./src/Components/Listview/Document/Document.js